import React, { PureComponent } from 'react';

class PluginView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    const { logout } = this.props;
    return (
      <div>
        <h1>Chrome Plugin Running</h1>
        <p><a href="#" onClick={e=>{
          e.preventDefault();
          logout();
        }}>Logout</a></p>
      </div>
    )
  }
}

export default PluginView;



// WEBPACK FOOTER //
// ./src/app/modules/Plugin/Plugin.view.js